import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAllProjectsQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  page: Types.PageInput;
  filter?: Types.InputMaybe<Types.AccountProjectFilter>;
  orders?: Types.InputMaybe<Array<Types.ProjectOrderInput>>;
}>;


export type GetAllProjectsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, allProjects: { __typename?: 'ProjectConnection', nodes: Array<{ __typename?: 'Project', id: string, mountedStorageStatus?: Types.MountedStorageStatus | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } | null };


export const GetAllProjects = /*#__PURE__*/ gql`
    query GetAllProjects($accountId: ID!, $page: PageInput!, $filter: AccountProjectFilter, $orders: [ProjectOrderInput!]) {
  account(accountId: $accountId) {
    id
    allProjects: projects(page: $page, filter: $filter, orders: $orders) {
      nodes {
        id
        mountedStorageStatus
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ` as unknown as DocumentNode<GetAllProjectsQuery, GetAllProjectsQueryVariables>;

          

          export const useGetAllProjectsQuery = (options?:QueryHookOptions<GetAllProjectsQuery, GetAllProjectsQueryVariables>) => useQuery(GetAllProjects, options);

          

          export type GetAllProjectsQueryOptions = QueryHookOptions<GetAllProjectsQuery, GetAllProjectsQueryVariables>;

          

          export const useGetAllProjectsLazyQuery = (options?:LazyQueryHookOptions<GetAllProjectsQuery, GetAllProjectsQueryVariables>) => useLazyQuery(GetAllProjects, options);

          

          export type GetAllProjectsQueryResult = ReturnType<typeof useGetAllProjectsQuery>;

          
